/**
 * Vérifie si la valeur est présente dans l'enum
 * @param value Valeur a tester
 * @param enumerator Enum
 */
export function isInEnumValues<T>(value: any, enumerator: T): boolean {
    return Object.values(enumerator).includes(value);
}

/**
 * Vérifie si la clé est présente dans l'enum
 * @param key Clé a tester
 * @param enumerator Enum
 */
export function isEnumKey<T extends object>(key: string | number | keyof T, enumerator: T): key is keyof T {
    return key as string in enumerator;
}
